import { Select } from "antd";
import styled from "styled-components";

const SelectStyled = styled(Select)`
  max-width: 300px;
  min-width: 200px;
`

export { SelectStyled };